/* eslint-disable sonarjs/no-duplicate-string */
// eslint-disable-next-line import/prefer-default-export
export var DOCUMENTS_TRANSLATIONS = {
    documents: {
        front: 'Frente del documento',
        back: 'Reverso del documento',
        important: 'Importante',
        importantPoint1: 'Todos los documentos deben coincidir con <b>el titular o razón social.</b>',
        importantPoint2: 'Los documentos deben ser <b>claros, legibles, vigentes y completos (Ej. ambas caras).</b>',
        importantPoint3: 'Si el documento contiene una clave, <b>agrégalo en el nombre del archivo.</b>',
        title: {
            one: 'Arrastra el archivo aquí, o',
            other: 'Arrastra los archivos aquí, o',
        },
        selectFile: {
            one: 'Selecciona un archivo',
            other: 'Selecciona los archivos',
        },
        allowedExtensions: 'Formatos:',
        maxSize: 'Tamaño máximo:',
        minResolution: 'Resolución mínima:',
        example: 'Ejemplo de documento',
        removeFile: 'Eliminar archivo',
        agreed: 'Entendido',
        error: {
            title: 'Hubo un error al cargar',
            tooLarge: 'El tamaño del archivo es mayor al permitido',
            tooSmall: 'La resolución de la imagen es menor a la permitida',
            invalidType: 'El formato del archivo no es el permitido',
            tooManyFiles: {
                one: 'Máximo 1 archivo} ',
                other: 'Máximo {{quantity}} archivos}}',
            },
            genericError: 'Intentar nuevamente',
            requiredFile: 'Este documento es requerido',
            summary: 'Hemos encontrado un error con sus documentos, por favor reviselos y subalos nuevamente.',
        },
        camera: {
            cancel: 'Cancelar',
            frontPicture: 'Encuadra y toma una foto delantera del documento',
            backPicture: 'Encuadra y toma una foto trasera del documento',
            picturesReady: 'Están listas las fotos del documento, dales un vistazo y revisa cómo quedaron.',
            frontPreview: 'Frente del documento',
            backPreview: 'Reverso del documento',
            requiredField: 'Campo requerido',
            start: 'Comenzar',
            ok: 'Ok',
            replaceImage: 'Reemplazar imagen',
            continue: 'Continuar',
        },
        hygieneCertification: {
            AR: 'Se debe adjuntar el certificado de habilitación vigente (correspondiente al establecimiento), emitida por el ente controlador de acuerdo a cada municipalidad.',
        },
        identification: {
            CO: {
                DEFAULT: 'Adjuntar el documento de identidad vigente y debe enviarse por la cara frontal y reverso.',
                Personanatural: 'Adjuntar el documento vigente y debe enviarse por la cara frontal y reverso.',
                Personajuridica: 'Adjuntar el documento vigente y debe enviarse por la cara frontal y reverso.',
            },
            AR: {
                DEFAULT: 'Se debe adjuntar el documento de identidad DNI por parte frontal y reverso.',
                Personahumana: 'Se debe adjuntar el documento de identidad DNI por parte frontal y reverso.',
                Personajuridica: 'Se debe adjuntar el documento de identidad DNI por parte frontal y reverso.',
            },
            UY: {
                DEFAULT: 'Se debe adjuntar Cedula de Identidad por ambas caras(reverso y adverso) o Pasaporte vigente.',
                Personanatural: 'Se debe adjuntar Cedula de Identidad por ambas caras(reverso y adverso) o Pasaporte vigente.',
                Personajuridica: 'Se debe adjuntar Cedula de Identidad por ambas caras(reverso y adverso) o Pasaporte vigente.',
            },
            CR: {
                DEFAULT: 'Adjuntar la cédula física o DIMEX. El documento debe estar vigente.',
                Personanatural: 'Adjuntar la cara frontal de la cédula física o DIMEX. El documento debe estar vigente.',
                Personajuridica: 'Adjuntar cédula física o DIMEX. El documento debe estar vigente.',
            },
            BR: {
                DEFAULT: 'Anexar documento legal com foto e número de identificação do RG e CPF',
                Pessoafisica: 'Qualquer documento legal com foto e número de identificação do RG e CPF',
                Pessoajuridica: 'Qualquer documento legal com foto e número de identificação do RG e CPF',
                Personanatural: 'Anexe o documento atual e deve ser enviado na frente e no verso.',
            },
            CL: {
                DEFAULT: 'Adjuntar la cédula de identidad vigente y debe enviarse por la cara frontal y reverso.',
                Personanatural: 'Adjuntar la cédula de identidad vigente y debe enviarse por la cara frontal y reverso.',
                Personajuridica: 'Adjuntar la cédula de identidad vigente y debe enviarse por la cara frontal y reverso.',
            },
            EC: {
                DEFAULT: 'Adjuntar la cédula de identidad vigente y debe enviarse por la cara frontal y reverso.',
                Personanatural: 'El documento debe estar vigente y se debe adjuntar la parte frontal y el reverso. El nombre debe coincidir con el nombre del representante legal que se refleja en el RUC.',
                Personajuridica: 'El documento debe estar vigente y se debe adjuntar la parte frontal y el reverso. El nombre debe coincidir con el nombre del representante legal que se refleja en el RUC.',
            },
            PE: {
                DEFAULT: 'El documento debe ser legible y se debe adjuntar la parte frontal. El nombre debe coincidir con el nombre del representante legal que se refleja en el RUC.',
                Personanatural: 'El documento debe ser legible y se debe adjuntar la parte frontal. El nombre debe coincidir con el nombre del representante legal que se refleja en el RUC.',
                Personajuridica: 'El documento debe ser legible y se debe adjuntar la parte frontal. El nombre debe coincidir con el nombre del representante legal que se refleja en el RUC.',
            },
            MX: {
                DEFAULT: 'El documento debe estar vigente y se debe adjuntar la parte frontal y el reverso.',
                Personafisica: 'El documento debe estar vigente y se debe adjuntar la parte frontal y el reverso.',
                Personamoral: 'El documento debe estar vigente y se debe adjuntar la parte frontal y el reverso. El nombre debe coincidir con el nombre del representante legal que se refleja en el Acta Constitutiva como administrador único.',
            },
        },
        bankCertification: {
            CO: {
                DEFAULT: 'Expedido por la entidad bancaria, debe contener el número de cuenta y nombre del titular. El producto debe estar activo. El certificado debe tener una vigencia de máximo 2 meses.',
                Personanatural: 'Expedido por la entidad bancaria, debe contener el número de cuenta y nombre del titular. El producto debe estar activo. El certificado debe tener una vigencia de máximo 2 meses.',
                Personajuridica: 'Expedido por la entidad bancaria, debe contener el número de cuenta y nombre del titular. El producto debe estar activo. El certificado debe tener una vigencia de máximo 2 meses.',
            },
            AR: {
                DEFAULT: 'Se debe adjuntar documento bancario en el que se pueda visualizar nombre del titular, número de CBU, número de cuenta, número de CUIT o Cuil y nombre del banco.',
                Personahumana: 'Se debe adjuntar documento bancario en el que se pueda visualizar nombre del titular, número de CBU, número de cuenta, número de CUIT o Cuil y nombre del banco.',
                Personajuridica: 'Se debe adjuntar documento bancario en el que se pueda visualizar nombre del titular, número de CBU, número de cuenta, número de CUIT o Cuil y nombre del banco.',
            },
            UY: {
                DEFAULT: 'Se debe adjuntar certificado bancario donde se logre identificar número de documento del mismo, nombre de la entidad bancaria y número de cuenta.',
                Personanatural: 'Se debe adjuntar certificado bancario donde se logre identificar número de documento del mismo, nombre de la entidad bancaria y número de cuenta.',
                Personajuridica: 'Se debe adjuntar certificado bancario donde se logre identificar número de documento del mismo, nombre de la entidad bancaria y número de cuenta.',
            },
            CR: {
                DEFAULT: 'El documento debe contar con nombre del titular, nombre de la entidad bancaria y numero de cuenta. El producto debe estar activo.',
                Personanatural: 'El documento debe contar con nombre del titular, nombre de la entidad bancaria y numero de cuenta. El producto debe estar activo.',
                Personajuridica: 'El documento debe contar con nombre del titular, nombre de la entidad bancaria y numero de cuenta. El producto debe estar activo.',
            },
            BR: {
                DEFAULT: 'Comprovante de conta bancária, contendo o número da agência e a conta bancária',
                Personanatural: 'Comprovante de conta bancária, contendo o número da agência e a conta bancária da PF',
                Personajuridica: 'Comprovante de conta bancária, contendo o número da agência e a conta bancária da PJ',
                Pessoajuridica: 'Comprovante de conta bancária, contendo o número da agência e a conta bancária da PJ',
            },
            CL: {
                DEFAULT: 'Expedido por la entidad bancaria, debe contener el número de cuenta y nombre del titular. El producto debe estar activo.',
                Personanatural: 'Expedido por la entidad bancaria, debe contener el número de cuenta y nombre del titular. El producto debe estar activo.',
                Personajuridica: 'Expedido por la entidad bancaria, debe contener el número de cuenta y nombre del titular. El producto debe estar activo.',
            },
            EC: {
                DEFAULT: 'Expedido por la entidad bancaria, debe contener el número de cuenta y nombre del titular. El producto debe estar activo.',
                Personanatural: 'Expedido por la entidad bancaria, debe contener el número de cuenta y nombre del titular. El producto debe estar activo.',
                Personajuridica: 'Expedido por la entidad bancaria, debe contener el número de cuenta y nombre del titular. El producto debe estar activo.',
            },
            PE: {
                DEFAULT: 'Expedido por la entidad bancaria, debe contener  el nombre del titular, Codigo de Cuenta Interbancaria (CCI) y numero de cuenta. El producto debe estar activo.',
                Personanatural: 'Expedido por la entidad bancaria, debe contener  el nombre del titular, Codigo de Cuenta Interbancaria (CCI) y numero de cuenta. El producto debe estar activo.',
                Personajuridica: 'Expedido por la entidad bancaria, debe contener  el nombre del titular, Codigo de Cuenta Interbancaria (CCI) y numero de cuenta. El producto debe estar activo.',
            },
            MX: {
                DEFAULT: 'Expedido por la entidad bancaria, debe contener  el nombre del titular, Clabe Interbancaria, y numero de cuenta. El producto debe estar activo.',
                Personafisica: 'Expedido por la entidad bancaria, debe contener  el nombre del titular, Clabe Interbancaria, y numero de cuenta. El producto debe estar activo.',
                Personamoral: 'Expedido por la entidad bancaria, debe contener  el nombre del titular, Clabe Interbancaria, y numero de cuenta. El producto debe estar activo.',
            },
        },
        rut: {
            CO: {
                DEFAULT: 'Debe contener el número de NIT, nombre de razón social, nombre del representante legal, domicilio fiscal y una vigencia del 2019-2020 o la más reciente al año en curso.',
                Personanatural: 'Debe contener el número de NIT, nombre de razón social, nombre del representante legal, domicilio fiscal y una vigencia del 2019-2020 o la más reciente al año en curso.',
                Personajuridica: 'Debe contener el número de NIT, nombre de razón social, nombre del representante legal, domicilio fiscal y una vigencia del 2019-2020 o la más reciente al año en curso.',
            },
            AR: {
                DEFAULT: 'Se debe adjuntar la constancia tributaria AFIP vigente. Debe contener numero de CUIT/CUIL y nombre de la razón social.',
                Personahumana: 'Se debe adjuntar la constancia tributaria AFIP vigente. Debe contener numero de CUIT/CUIL y nombre de la razón social.',
                Personajuridica: 'Se debe adjuntar la constancia tributaria AFIP vigente. Debe contener numero de CUIT/CUIL y nombre de la razón social.',
            },
            UY: {
                DEFAULT: 'Se debe adjuntar la constancia DGI expedida por la Dirección General Impositiva vigente. Debe contener numero de RUT, domicilio fiscal y nombre de razón social.',
                Personanatural: 'Se debe adjuntar la constancia DGI expedida por la Dirección General Impositiva vigente. Debe contener numero de RUT, domicilio fiscal y nombre de razón social.',
                Personajuridica: 'Se debe adjuntar la constancia DGI expedida por la Dirección General Impositiva vigente. Debe contener numero de RUT, domicilio fiscal, nombre de razón social y nombre del representante legal.',
            },
            CR: {
                DEFAULT: 'Adjuntar el documento de razón social ante la administración tributaria de Costa Rica. Debe estar registrado y vigente.',
                Personanatural: 'Adjuntar el documento de razón social ante la administración tributaria de Costa Rica. Debe estar registrado y vigente.',
                Personajuridica: 'Adjuntar el documento de razón social ante la administración tributaria de Costa Rica. Debe estar registrado y vigente.',
            },
            BR: {
                DEFAULT: 'A empresa deve estar no ramo alimentício e ativo na receita federal',
                Persoanatural: 'A empresa deve estar no ramo alimentício e ativo na receita federal',
                Pessoajuridica: 'A empresa deve estar no ramo alimentício e ativo na receita federal',
            },
            CL: {
                DEFAULT: 'Se debe adjuntar el documento expedido por el Servicio de Impuestos Internos. Debe contener el número de e-RUC, nombre del representante legal y nombre de la razón social.',
                Personanatural: 'Se debe adjuntar el documento expedido por el Servicio de Impuestos Internos. Debe contener el número de e-RUC, nombre del representante legal y nombre de la razón social.',
                Personajuridica: 'Se debe adjuntar el documento expedido por el Servicio de Impuestos Internos. Debe contener el número de e-RUC, nombre del representante legal, nombre de la razón social y tipo de societario.',
            },
            EC: {
                DEFAULT: 'Debe contener el número de RUC, nombre del representante legal y nombre de la razón social.',
                Personanatural: 'Debe contener el número de RUC, nombre del representante legal y nombre de la razón social.',
                Personajuridica: 'Debe contener el número de RUC, nombre del representante legal, nombre de la razón social y  tipo de societario.',
            },
            PE: {
                DEFAULT: 'El documento debe esta activo y debe contener el número de RUC, nombre del representante legal y nombre de la razón social.',
                Personanatural: 'El documento debe esta activo y debe contener el número de RUC, nombre del representante legal y nombre de la razón social.',
                Personajuridica: 'El documento debe esta activo y debe contener el número de RUC, nombre del representante legal y nombre de la razón social y tipo de societario.',
            },
            MX: {
                DEFAULT: 'Deben contener el número RFC, nombre de la razón social, tipo de régimen fiscal y dirección. Debe contener QR para validar.',
                Personafisica: 'Deben contener el número de CURP, número RFC, nombre del representante legal, nombre de la razón social y dirección.',
                Personamoral: 'Deben contener el número RFC, nombre de la razón social, tipo de régimen fiscal y dirección. Debe contener QR para validar.',
            },
        },
        ecommerce: {
            CO: {
                DEFAULT: 'N/A',
                Personanatural: 'N/A',
                Personajuridica: 'Debe adjuntarse completo, contener el  tipo de societario nombre del representante legal, NIT, razón social, domicilio fiscal. Vigencia 2019-2020 o la mas reciente al año en curso.( no se valida tiempo de vigencia, se estipulan estos años para que el documento venga completo,porque nuestro lado tambien se valida con la DIAN.',
            },
            AR: {
                DEFAULT: 'Aplica para todo el país, vigencia de seis meses a la actual fecha, emitida por la agencia gubernamental de control para cada ciudad.',
                Personahumana: 'Aplica para todo el país, vigencia de seis meses a la actual fecha, emitida por la agencia gubernamental de control para cada ciudad.',
                Personajuridica: 'Aplica para todo el país, vigencia de seis meses a la actual fecha, emitida por la agencia gubernamental de control para cada ciudad.',
            },
            UY: {
                DEFAULT: 'N/A',
                Personanatural: 'N/A',
                Personajuridica: 'Debe contener nombre del representante legal, nombre de la razón social y autenticado por notaria.',
            },
            MX: {
                DEFAULT: 'Se deben visualizar datos obligatorios como tipo de societario, nombre del administrador único, nombre de la empresa y firma.',
                Personamoral: 'Se deben visualizar datos obligatorios como tipo de societario, nombre del administrador único, nombre de la empresa y firma.',
            },
        },
        legal: {
            AR: {
                DEFAULT: 'N/A',
                Personanatural: 'N/A',
                Personajuridica: 'El documento debe adjuntarse completo y vigente.',
            },
            CL: {
                DEFAULT: 'N/A',
                Personanatural: 'N/A',
                Personajuridica: 'Adjuntar el Certificado de Registro de Santiago completo y legible (el cual debe contar con una vigencia máxima de 6 meses a la actual fecha) o también puede adjuntar el certificado de estatuto actualizado y completo.',
            },
            EC: {
                DEFAULT: 'N/A',
                Personanatural: 'N/A',
                Personajuridica: 'El documento debe ser legible y debe contar con fecha, periodo de vigencia, nombre y cargo. El nombramiento debe enviarse con el nombre del representante legal que no necesariamente debe ser el mismo que registra en el RUC.',
            },
            MX: {
                DEFAULT: 'Debe estar autenticado en notaría.',
                Personamoral: 'Debe estar autenticado en notaría.',
            },
        },
    },
};
